import React, {  Component } from 'react';

class SalesAgreementHandbook extends Component {
    render() {
        return (
            <div>
                <h1 className="pageTitle" style={{margin: '21px 0'}}>Customer Agreement Handbooks</h1>
                <p>In order to view or print any available handbook(s) below, you will need <a href="https://get.adobe.com/reader/" target="_blank">Adobe© Acrobat© Reader™</a><br />&nbsp;</p>
                <p><a target="_blank" href="http://images.salsify.com/image/upload/s--A5k5OIJ7--/qysmfbzovqxytw30ozje.pdf">Dealer Handbook</a><span className="acroIcon" /><br />&nbsp;</p>
                <p><a target="_blank" href="http://images.salsify.com/image/upload/s--nIIpdeHn--/kul6zytavzehxhttprx2.pdf">Distributor Handbook</a><span className="acroIcon" /><br />&nbsp;</p>
                <p><a target="_blank" href="http://images.salsify.com/image/upload/s--ZhXVUp1j--/gbct3piapr08wopwwbva.pdf">Monogram Handbook</a><span className="acroIcon" /><br />&nbsp;</p>
                <p><a target="_blank" href="http://images.salsify.com/image/upload/s--ZB0QcgMd--/kifjtomfzwcuctwxiwwz.pdf">Air & Water Distributor Handbook</a><span className="acroIcon" /><br />&nbsp;</p>
                <p><a target="_blank" href="http://images.salsify.com/image/upload/s--FDXZJEHo--/r5dqvpsqwgwulv0dn3ay.pdf">As-Is Handbook</a><span className="acroIcon" /><br />&nbsp;</p>
                <p><a target="_blank" href="http://images.salsify.com/image/upload/s--BnUJpI93--/tkwfdsye3sqzyrdxigqz.pdf">Parts Distributor Handbook</a><span className="acroIcon" /><br />&nbsp;</p>
                <p><a target="_blank" href="http://images.salsify.com/image/upload/s--Cv-2o4Ua--/k1b3idupublti61mjtdl.pdf">Commercial Laundry Reseller Handbook</a><span className="acroIcon" /><br />&nbsp;</p>
            </div>
        );
    }
}

export default SalesAgreementHandbook;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Resources/SalesAgreement/salesAgreementHandbook.js